import "./bootstrap";
import "bootstrap3/dist/js/bootstrap";
import "owl.carousel/dist/owl.carousel";
import "jquery-validation/dist/jquery.validate";
import 'jquery-confirm';